import React from "react";
import { Button } from "../../../../../design/button";
import { Label } from "../../../../../design/fieldset";
import OnboardingContainer from "../../../components/OnboardingContainer";
import {
  ProfessionalRoleType,
  professionalRoleTypes,
} from "../../../../../models/ProfessionalRoleType";
import { Professional } from "../../../../../models/Professional";
import { Checkbox, CheckboxField } from "../../../../../design/checkbox";

const OnboardingSelectRolesStep: React.FC<{
  formData: Partial<Professional>;
  setFormData: React.Dispatch<React.SetStateAction<Partial<Professional>>>;
  onBack: () => void;
  onStepComplete: () => void;
}> = ({ onBack, onStepComplete, formData, setFormData }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.roles && formData.roles.length > 0) {
      onStepComplete();
    }
  };

  return (
    <OnboardingContainer
      title="Your Roles"
      subtitle="What type of roles do you provide?"
    >
      <>
        <form onSubmit={handleSubmit} className="space-y-6">
          {Object.entries(professionalRoleTypes).map(([key, service]) => (
            <CheckboxField key={key} className="flex items-center">
              <Label>{service}</Label>
              <Checkbox
                checked={formData.roles?.includes(key as ProfessionalRoleType)}
                onChange={(checked) => {
                  const selectedRoles = formData.roles || [];
                  if (checked) {
                    setFormData({
                      ...formData,
                      roles: [...selectedRoles, key as ProfessionalRoleType],
                    });
                  } else {
                    setFormData({
                      ...formData,
                      roles: selectedRoles.filter((s) => s !== key),
                    });
                  }
                }}
              />
            </CheckboxField>
          ))}
          <Button
            type="submit"
            className="w-full"
            disabled={!formData.roles?.length}
          >
            Continue
          </Button>
        </form>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingSelectRolesStep;
